// src/redux/reducers/rootReducer.js
import { combineReducers } from 'redux';
import authReducer from './authReducer';
import userReducer from './userReducer';
import logReducer from './logReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  log: logReducer,
});

export default rootReducer;
